import React from 'react';

const SearchSVG = ({ className, parentClassName }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={parentClassName}
    >
      <path
        d="M19.7581 18.586L14.859 13.6894C16.0863 12.1915 16.7593 10.3172 16.7593 8.38142C16.7593 3.75895 12.9996 0 8.38068 0C7.25153 0 6.1551 0.220994 5.12209 0.658891C4.12386 1.08246 3.2279 1.68611 2.45877 2.45549C1.68964 3.22488 1.08415 4.12114 0.660717 5.1197C0.222967 6.15306 0 7.24985 0 8.37937C0 13.0018 3.75975 16.7608 8.37863 16.7608C10.3158 16.7608 12.1875 16.0876 13.6848 14.8598L18.5799 19.7565C18.7374 19.9141 18.946 20 19.1669 20C19.3899 20 19.5986 19.9141 19.754 19.7565C20.0813 19.4352 20.0813 18.9093 19.7581 18.586ZM15.1004 8.37937C15.1004 12.0872 12.0852 15.1013 8.38068 15.1013C4.67411 15.1013 1.661 12.0851 1.661 8.37937C1.661 4.67362 4.67616 1.65746 8.38068 1.65746C12.0852 1.65746 15.1004 4.67362 15.1004 8.37937Z"
        fill="#263154"
      />
    </svg>
  );
};

export { SearchSVG };
